import {
  Button,
  ButtonBase,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Zoom,
} from "@material-ui/core";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { navigate } from "../../../actions/routerResolve.js";
import { msgAction, msgSimple } from "../../../actions/snackbarActions.js";
import Step from "../../../components/Step.js";
import View from "../../../components/View.js";
import add from "../../../images/add.svg";
import { colors, metrics } from "../../../styles/index.js";
import AircraftsService from "../../../tools/AircraftsService.js";
import AircraftsTypesService from "../../../tools/AircraftsTypesService.js";
import CostCenterService from "../../../tools/CostCenterService.js";
import FlightStageService from "../../../tools/FlightStageService.js";
import MissionService from "../../../tools/MissionService.js";
import Modal from "./Modal.js";
import PassengersModal from "../../../routes/settings/passengers/Modal.js"
//SweetAlert
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MISSION_STATUS } from "../../../enums.js";
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers/index.js';
import MomentUtils from 'material-ui-pickers/utils/moment-utils.js';
import MultiSelect from '../../../components/MultiSelect.js';
import PassengerService from '../../../tools/PassengerService.js';
import NotificationGroups from '../../../tools/NotificationGroups.js';

const MySwal = withReactContent(Swal);

class MissionV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUpdate: false,
      openModal: false,
      openPax: false,
      loading: false,
      modalPax: { id: 'new' },
      mission: {
        id: "new",
        status: "Solicitado",
        cost_center_id: "",
        flight_denomination: "",
        aircraft_type_id: "",
        aircraft_id: "",
        flight_stages: [],
        notification_groups: []
      },
      profiles: ["Teste", "Teste 2"],
      user: {
        profile: "",
      },
      costCenter: [],
      aircraftTypes: [],
      aircrafts: [],
      modal: { id: "new" },
      clickedIndex: 0,
      firstStep: {
        from: '',
        to: '',
        status: 'Solicitado',
        date: null,
        local_time: null,
        arrival_date: null,
        arrival_time: null,
        passengers: [],
        observations: '',
        logbook_number: ''
      },
      notificationGroups: [],

    };
  }

  handleRefreshState = async () => {
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let passengers = await this._handleIdPassengerMultiSelect(
            result.response.docs
          );
          this.setState({
            passengers: passengers,
          });
        } else {
          console.log(`Error ao tentar recuperar os passageiros`);
        }
      }
    );
  };

  openPaxDialog = (value) => {
    if (value) {
      this.setState({ newPax: value });
    }
    this.setState({ openPax: !this.state.openPax });
  };

  handleClosePax = () => {
    this.setState({ openPax: !this.state.openPax });
  };

  handleSavePax = (item) => {
    Swal.fire({
      title:
        "<strong>Deseja realmente salvar as alterações realizadas?</strong>",
      type: "info",
      // html:'',
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Salvar',
      confirmButtonAriaLabel: "Salvar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then((result) => {
      console.log(item);
      if (!!result.value) {
        //Save user
        if (item.id === "new") {
          let { passengers } = this.state;
          passengers.push({ ...item });
          passengers.reverse();
          this.setState({ passengers });
          this.setState({ loading: true })
          delete item.id;
          PassengerService.create(item).then((result) => {
            if (result.ok) {
              this.handleRefreshState();
              this.props.msgSimple(item.first_name + ' ' + item.last_name + " criado com sucesso.");
            } else {
              let { passengers } = this.state;
              passengers = passengers.filter((e) => e.id !== "new");
              passengers.reverse();
              this.setState({ passengers });
              this.props.msgAction(
                'Erro ao criar "' + item.first_name + ' ' + item.last_name + '"',
                "TENTAR NOVAMENTE",
                () => this.handleSave(item)
              );
            }
          });
        }
        this.setState({ openPax: false, loading: false });
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  _handleIdPassengerMultiSelect = async (value) => {
    if (value) {
      return await value.map((element) => {
        let label = [];
        label = label.concat(
          (element.first_name ? element.first_name : "") +
          " " +
          (element.last_name ? element.last_name : "") +
          " - " +
          (element.cpf ? element.cpf : "")
        );
        return { value: element.id, label: label };
      });
    }
    return null;
  };
  _handleIdMultiSelectNG = async value => {
    if (value) {
      return await value.map(element => {
        if (element.users)
          return { value: element.id, label: element.name, groups: element.users }
        else
          return { value: element.id, label: element.name }
      })
    }
    return null;
  }

  getProperty = async()=>{
    this.setState({isUpdate:true})
      MissionService.getById(this.props.match.params.id).then((result) => {
        if (result.ok) {
          let { mission } = this.state;
          this.setState({
            mission: {
              ...mission,
              id:result.response.id,
              flight_stages: result.response.flight_stages,
              flight_denomination:result.response.flight_denomination
            },
          });
          this.setState({ isChanged: true });
        }
      });
  }
  async componentWillMount() {
    NotificationGroups.getActive().then(async result => {
      if (result.ok) {
        let listGroup = result.response
        this.setState({ notificationGroups: listGroup })
        let { mission } = this.state;
        this.setState({ mission: { ...mission, notification_groups: await this._handleIdGroups(listGroup) } })
      }
    })
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let passengers = await this._handleIdPassengerMultiSelect(
            result.response.docs
          );
          this.setState({
            passengers: passengers,
          });
        } else {
          console.log(`Error ao tentar recuperar os passageiros`);
        }
      }
    );
    CostCenterService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ costCenter: result.response });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, cost_center_id: result.response[0].id },
        });
      }
    });
    AircraftsTypesService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ aircraftTypes: result.response, loading: false });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, aircraft_type_id: result.response[0].id },
        });
      }
    });
    AircraftsService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ aircrafts: result.response, loading: false });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, aircraft_id: result.response[0].id },
        });
      }
    });
    if (this.props.match.params.id !== "new") {
      await this.getProperty()  
    } else {
      MissionService.getTitle().then((result) => {
        if (result.ok) {
          let { mission } = this.state;
          this.setState({
            mission: {
              ...mission,
              flight_denomination: result.response.flightTitle,
            },
          });
          this.setState({ isChanged: true });
        }
      });
    }
  }

  handleRefreshAircraft = () => { };

  handleClose = () => {
    this.setState({ openModal: !this.state.openModal });
  };

  handleClickOpen = (item) => {
    this.setState({ modal: item });
    this.setState({ openModal: !this.state.openModal });
  };

  handleTime = (value) => {
    if (value === "") {
      return null;
    } else {
      return value;
    }
  };
  handleDate = async (value) => {
    if (value) {
      return moment(value).format("YYYY-MM-DD");
    }
    return null;
  };

  handleSave = async (item, reopenModal = false) => {
    Swal.fire({
      title: "<strong>Deseja realmente salvar a missão?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ isChanged: false, loading: true });
        if (item.id === "new") {
          let { mission } = this.state;
          let { flight_stages } = this.state.mission;
          flight_stages.push({ ...item, id: "new" });
          this.setState({ mission: { ...mission, flight_stages } });
          moment.locale("pt-br");
          item.date = moment(item.date).format("YYYY-MM-DD");
          moment.locale("pt-br");
          // tratando datas
          item.date = await this.handleDate(item.date);
          item.departure_date = await this.handleDate(item.date);
          item.arrival_date = await this.handleDate(item.date);

          //Tratando horas
          let aux = item.local_time;
          item.local_time = this.handleTime(aux);
          item.takeoff_time = this.handleTime(aux);
          item.status = MISSION_STATUS.SOLICITADO;

          item.passengers = item.passengers.map((item) => item.value);

          delete item.id;
          FlightStageService.create(item).then((result) => {
            this.setState({ loading: false });
            if (result.ok) {
              this.props.msgAction("Etapa criada com sucesso.");
              let { mission } = this.state;
              let { flight_stages } = this.state.mission;
              flight_stages = flight_stages.filter(
                (element) => element.id !== "new"
              );
              flight_stages.push({ ...result.response });
              this.setState({ mission: { ...mission, flight_stages } });
            } else {
              let { mission } = this.state;
              let { flight_stages } = this.state.mission;
              flight_stages = flight_stages.filter(
                (element) => element.id !== "new"
              );
              this.setState({ mission: { ...mission, flight_stages } });
              this.props.msgAction(
                "Erro ao criar etapa",
                "TENTAR NOVAMENTE",
                () => this.handleSave({ ...item, id: "new" })
              );
            }
          });
        } else {
          let { mission } = this.state;
          let { flight_stages } = this.state.mission;
          let index = await flight_stages.findIndex(
            (element) => element.id === item.id
          );
          flight_stages[index].id = "new";
          this.setState({ mission: { ...mission, flight_stages } });
          moment.locale("pt-br");
          item.date = moment(item.date).format("YYYY-MM-DD");

          item.local_time = this.handleTime(item.local_time);
          item.passengers = item.passengers.map((item) => item.value);

          FlightStageService.update(item.id, item).then((result) => {
            if (result.ok) {
              let { mission } = this.state;
              let { flight_stages } = this.state.mission;
              let index = flight_stages.findIndex(
                (element) => element.id === "new"
              );
              flight_stages.splice(index, 1, { ...item });
              this.setState({ mission: { ...mission, flight_stages } });
              this.props.msgAction("Etapa editada com sucesso.");
            } else {
              let { flight_stages } = this.state.mission;
              let index = flight_stages.findIndex(
                (element) => element.id === item.id
              );
              flight_stages[index].id = item.id;
              this.props.msgAction(
                "Erro ao editar etapa",
                "TENTAR NOVAMENTE",
                () => this.handleSave({ ...item })
              );
            }
            this.setState({ loading: false });
          });
        }
        this.setState({ openModal: false });

        if (reopenModal) {
          let { flight_stages } = this.state.mission
          this.handleClickOpen({
            id: "new",
            from:
              flight_stages &&
                flight_stages.length > 0
                ? flight_stages.at(-1).to
                : "",
            date: item.date
          });
        }
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };
  handleId = value => {
    if (value) return value;
    return null;
  }
  _handleIdGroups = async value => {
    if (value) {
      let list = await value.map(element => element.id);
      return list;
    }
    return null;
  }
  _handleIdMultiSelect = async value => {
    if (value) {
      let list = await value.map(element => element.value);
      return list;
    }
    return null;
  }
  handleCreateStage = async (action) => {
    let item = this.state.firstStep

    // tratando datas
    item.date = await this.handleDate(item.date)
    item.departure_date = await this.handleDate(item.departure_date);
    item.arrival_date = await this.handleDate(item.arrival_date);

    //tratando horas
    item.departure_time = await this.handleTime(item.departure_time);
    item.local_time = await this.handleTime(item.local_time);
    item.presentation_time = await this.handleTime(item.presentation_time);
    item.hangar_time_departure = await this.handleTime(item.hangar_time_departure);
    item.takeoff_time = await this.handleTime(item.takeoff_time);
    item.arrival_time = await this.handleTime(item.arrival_time);
    item.takeoff_time_utc = await this.handleTime(item.takeoff_time_utc);
    item.arrival_time_utc = await this.handleTime(item.arrival_time_utc);
    item.flight_time = await this.handleTime(item.flight_time);
    item.passengers = this.state.firstStep.passengers.map((item) => item.value);

    delete item.id;

    FlightStageService.create(item).then(result => {
      if (result.ok) {
        FlightStageService.getById(result.response.id).then(async res => {
          if (res.ok) {
            let { mission } = this.state;
            let { flight_stages, aircraft_type_id, aircraft_id, notification_groups, notification_users } = this.state.mission;

            if (this.state.firstStep.date)
              mission.date = await this.handleDate(this.state.firstStep.date)
            // mission.date.setHours(flight_stages[0].presentation_time)
            flight_stages.push({ ...res.response })
            flight_stages = flight_stages.map(element => element.id)

            //To delete the id
            delete mission.id
            MissionService.create({
              ...mission,
              flight_stages,
              aircraft_id: aircraft_id ? await this.handleId(aircraft_id) : null,
              aircraft_type_id: aircraft_type_id ? await this.handleId(aircraft_type_id) : null,
              notification_users: await this._handleIdMultiSelect(notification_users),
            }).then(result => {
              if (result.ok) {
                this.setState({ loading: false });
                if(action==='new')
                  (this.props.navigate('/new-mission/' + result.response.id))
                else{
                  (this.props.navigate('/'))
                }
                this.getProperty()
                this.props.msgSimple('Missão criada com sucesso.');
              } else {
                this.setState({ loading: false });

                this.props.msgSimple('Não foi possível criar missão.');
              }
            })
          }
        })
      }
    })
  }

  handleSaveMission = (action) => {
    Swal.fire({
      title: "<strong>Deseja realmente salvar a missão?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ loading: true });
        if (this.state.firstStep.from !== '' || this.state.firstStep.to !== '') {
          this.handleCreateStage(action)
        } else {
          this.setState({ loading: false });
          this.props.msgSimple('Para criar missão é necessário preencher o Local de Embarque e Destino');
        }


      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  handleUpdateMission = async () => {
    Swal.fire({
      title: '<strong>Deseja realmente salvar a missão?</strong>',
      type: 'info',
      customClass: '{ z-index: 1000000 }',
      customContainerClass: '{ z-index: 100000 }',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: 'Sim',
      cancelButtonText:
        '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: 'Não',
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ loading: true });
        if (this.state.mission.flight_stages.length > 0 && this.state.mission.cost_center_id) {
          let { mission } = this.state;
          let { flight_stages, aircraft_type_id, aircraft_id, notification_groups, notification_users } = this.state.mission;

          mission.date = flight_stages[0].date
          // mission.date.setHours(flight_stages[0].presentation_time)
          flight_stages = flight_stages.map(element => element.id);
          MissionService.update(this.state.mission.id, {
            ...mission,
            flight_stages,
            aircraft_id: await this.handleId(aircraft_id),
            aircraft_type_id: await this.handleId(aircraft_type_id),
            notification_users: await this._handleIdMultiSelect(notification_users),
          }).then(result => {
            if (result.ok) {
              this.setState({ loading: false });
              (this.props.navigate('/flight/' + this.props.match.params.id))
              this.props.msgSimple('Missão atualizada com sucesso.');

            } else {
              this.props.msgSimple('Não foi possível atualizar missão.');
              this.setState({ loading: false });
            }
          })
        } else {
          this.props.msgSimple('Para atualizar missão é necessário uma etapa');
          this.setState({ loading: false });
        }
      } else
        return MySwal.fire({ title: '<p>Operação cancelada!</p>', type: 'error' })
    })
  }

  render() {
    return (
      <main>
        <Zoom in={true}>
          <Grid container item md={12}>
            <Dialog open={this.state.loading}>
              <DialogContent>
                <CircularProgress />
              </DialogContent>
            </Dialog>
            <View {...this.state.mission} />

            <Modal
              openModal={this.state.openModal}
              func={this.handleClose}
              modal={this.state.modal}
              handleSave={this.handleSave}
              minDate={this.state.minDate}
              lastStep={this.state.clickedIndex > 0 ? this.state.mission.flight_stages[this.state.clickedIndex - 1] : null}
            />
            <PassengersModal
              modal={this.state.modalPax}
              openModal={this.state.openPax}
              func={this.handleClosePax}
              handleSave={this.handleSavePax}
            />
            <Grid container style={styles.iboxMain}>
              <Paper style={{ width: "100%", padding: metrics.paddingPage }}>
                <Grid container spacing={8}>
                  {/* Dados fixos */}
                  <Grid item xs={12} md={4}>
                    <TextField
                      InputProps={{
                        readOnly: true,
                      }}
                      id="flight_denomination"
                      label="Título do voo"
                      style={{ width: "100%" }}
                      value={this.state.mission.flight_denomination}
                      onChange={(event) => {
                        let { mission } = this.state;
                        this.setState({
                          mission: {
                            ...mission,
                            flight_denomination: event.target.value.toUpperCase(),
                          },
                        });
                        this.setState({ isChanged: true });
                      }}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="type_aircraft"
                      select
                      label="Tipo"
                      required
                      style={{ width: "100%" }}
                      value={this.state.mission.aircraft_type_id}
                      onChange={(event) => {
                        let { mission } = this.state;
                        this.setState({
                          mission: {
                            ...mission,
                            aircraft_type_id: event.target.value,
                          },
                        });
                      }}
                      margin="normal"
                      InputProps={{
                        readOnly: true,
                      }}
                    >
                      <MenuItem disabled>Selecione o tipo de aeronave</MenuItem>
                      {this.state.aircraftTypes.map((element) => (
                        <MenuItem key={element.id} value={element.id}>
                          {element.type}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="profile"
                      select
                      label="Aeronave"
                      style={{ width: "100%" }}
                      value={this.state.mission.aircraft_id}
                      onChange={(event) => {
                        let { mission } = this.state;
                        this.setState({
                          mission: {
                            ...mission,
                            aircraft_id: event.target.value,
                          },
                        });
                      }}
                      margin="normal"
                      // InputProps={{
                      //   readOnly: true,
                      // }}
                    >
                      <MenuItem disabled>Selecione o Perfil</MenuItem>
                      {this.state.aircrafts.map((element) => (
                        <MenuItem key={element.id} value={element.id}>
                          {element.marks}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Dados do voo */}
                  {
                    !this.state.isUpdate &&
                    <React.Fragment>

                      {/* origem */}
                      <Grid container style={{ paddingTop: '24px' }} spacing={8}>
                        <Grid item xs={12}>
                          Origem
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                          <MuiPickersUtilsProvider
                            utils={MomentUtils}
                            moment={moment}
                            locale='pt-br'
                          >
                            <DatePicker
                              style={{ width: '100%' }}
                              label="Data de embarque"
                              disablePast
                              format='DD/MM/YYYY'
                              cancelLabel='SAIR'
                              okLabel='OK'
                              value={this.state.firstStep.date}
                              onChange={date => {
                                let { firstStep } = this.state;
                                this.setState({ firstStep: { ...firstStep, date: date, departure_date: date, arrival_date: date } })
                              }}
                              animateYearScrolling
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            id="from"
                            label="Local de embarque"
                            style={{ width: '100%' }}
                            value={this.state.firstStep.from}
                            onChange={event => {
                              let { firstStep } = this.state;
                              this.setState({ firstStep: { ...firstStep, from: event.target.value } })
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={4}>
                          <TextField
                            id="time"
                            label="Hora de partida"
                            type="time"
                            // defaultValue="00:00"
                            style={{ width: '100%' }}
                            value={this.state.firstStep.local_time}
                            onChange={event => {
                              let { firstStep } = this.state;
                              this.setState({ firstStep: { ...firstStep, local_time: event.target.value, takeoff_time: event.target.value } })
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 300, // 5 min
                            }}
                          />
                        </Grid>
                      </Grid>

                      {/* Destino */}
                      <Grid container spacing={8} style={{ paddingTop: '24px' }}>
                        <Grid item xs={12}>
                          Destino
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} >
                          <MuiPickersUtilsProvider
                            utils={MomentUtils}
                            moment={moment}
                            locale='pt-br'
                          >
                            <DatePicker
                              style={{ width: '100%' }}
                              label="Data de Chegada"
                              format='DD/MM/YYYY'
                              clearable
                              clearLabel={'LIMPAR'}
                              cancelLabel='SAIR'
                              okLabel='OK'
                              minDate={this.state.firstStep.date}
                              value={this.state.firstStep.arrival_date}
                              onChange={date => {
                                let { firstStep } = this.state;
                                this.setState({ firstStep: { ...firstStep, arrival_date: date } })
                              }}
                              animateYearScrolling
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            id="to"
                            label="Destino"
                            style={{ width: '100%' }}
                            value={this.state.firstStep.to}
                            onChange={event => {
                              let { firstStep } = this.state;
                              this.setState({ firstStep: { ...firstStep, to: event.target.value } })
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                          <TextField
                            id="time"
                            label="Hora de Chegada"
                            type="time"
                            // defaultValue="00:00"
                            style={{ width: '100%' }}
                            value={this.state.firstStep.arrival_time}
                            onChange={event => {
                              let { firstStep } = this.state;
                              this.setState({ firstStep: { ...firstStep, arrival_time: event.target.value } })
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 300, // 5 min
                            }}

                          />
                        </Grid>
                      </Grid>
                      {/* PASSAGEIROS */}
                      <Grid container spacing={8} style={{ marginTop: 40 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <MultiSelect
                            isPax={{
                              isPax: true,
                              openPaxDialog: this.openPaxDialog,
                            }}
                            value={this.state.firstStep.passengers}
                            suggestions={this.state.passengers}
                            placeholder="Selecione os Passageiros"
                            label="Passageiros"
                            onChange={(value) => {
                              let { firstStep } = this.state;
                              this.setState({
                                firstStep: { ...firstStep, passengers: value },
                              });
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <TextField
                            id="request_obs"
                            label="Observações "
                            style={{ width: '100%' }}
                            value={this.state.firstStep.observations}
                            onChange={event => {
                              let { firstStep } = this.state;
                              this.setState({ firstStep: { ...firstStep, observations: event.target.value } })
                            }}
                          />
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  }


                  {/* buttons */}
                  <Grid container spacing={8} style={{ marginTop: 20 }}>
                    <Grid item md={3}>
                      {
                        this.state.isUpdate &&
                        <ButtonBase
                          onClick={() => {
                            this.handleClickOpen({
                              id: "new",
                              from:
                                this.state.mission.flight_stages &&
                                  this.state.mission.flight_stages.length > 0
                                  ? this.state.mission.flight_stages.at(-1).to
                                  : "",
                              date: this.state.mission.flight_stages &&
                                this.state.mission.flight_stages.length > 0
                                ? this.state.mission.flight_stages.at(-1).arrival_date
                                : new Date()
                            })
                          }}
                          style={{
                            backgroundColor: colors.primary_darker,
                            padding: 10,
                            color: colors.white,
                            borderRadius: 10,
                            width: 150,
                            height: 60,
                          }}
                        >
                          <img
                            src={add}
                            alt="Nova etapa"
                            style={{ width: 40, height: 40 }}
                          />
                          <h4 style={{ margin: 0, marginLeft: 5 }}>NOVA ETAPA</h4>
                        </ButtonBase>
                      }
                    </Grid>
                    <Grid
                      container
                      item
                      alignItems="center"
                      justify="flex-end"
                      xs={12}
                      sm={12}
                      md={9}
                      lg={9}
                      xl={9}
                    >
                      {
                        this.state.isUpdate ?
                          <Button variant='contained' onClick={this.handleUpdateMission} color="primary">
                            Salvar
                          </Button>
                          :
                          <React.Fragment>
                            <Button variant='contained' onClick={()=>this.handleSaveMission('new')} color="primary">
                              Salvar e adicionar nova etapa
                            </Button>
                            <Button onClick={this.handleSaveMission}  style={{marginLeft:8,marginRight:8}} color="primary">
                              Salvar
                            </Button>

                          </React.Fragment>

                      }
                      <Button
                        onClick={() => this.props.navigate("/")}
                        color="secondary"
                      >
                        Cancelar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
              <Grid container spacing={8} style={{ marginTop: 10 }}>
                {this.state.mission.flight_stages.map((element, index) => (
                  <Step
                    index={index}
                    {...element}
                    onClick={() => {
                      this.setState({ clickedIndex: index })
                      this.handleClickOpen({ ...element })
                    }}
                  />
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Zoom>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users,
});

const mapDispatchToProps = {
  msgSimple,
  msgAction,
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(MissionV2);

const styles = {
  iboxMain: {
    paddingLeft: "4%",
    paddingRight: "4%",
    marginTop: -20,
  },
  paper: {
    padding: metrics.paddingPage,
  },
  item: {
    // padding:5
  },
};



// WEBPACK FOOTER //
// ./src/routes/missions/mission-v2/index.js